export default "__VITE_ASSET__iWKKvldY__"